import { render, staticRenderFns } from "./RsaEquipeComponent.vue?vue&type=template&id=087e7828"
import script from "./RsaEquipeComponent.vue?vue&type=script&lang=js"
export * from "./RsaEquipeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports